import React from "react"
import { Box } from "@mui/material"
import { GatsbyImage } from "gatsby-plugin-image"

const HeroImage = ({ image, alt, style }) => {
  return (
    <Box
      component={GatsbyImage}
      image={image}
      alt={`hero image ${alt}`}
      sx={{
        width: "100%",
        ...style,
      }}
    />
  )
}

export default HeroImage
